import React from "react";
import Modal from "../../../components/general/Modal";
import Button from "../../../components/general/Button";
import GlobalStyle from "../../../styles/globalStyles";
import { Container, SubTitle, Title, Footer } from "./styles";
import { handleDeleteUser } from "../../../state/users/actions";
import { useDispatch } from "react-redux";
import { toastAlert } from "../../../components/Toastify";

const DeleteUserModal = ({
  isOpen,
  onClose,
  item,
  updateFilters,
  typeFilter,
}) => {
  const dispatch = useDispatch();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector="#root"
      className="nodrag"
      items={item}
    >
      <GlobalStyle />
      <Container>
        <Title>Aviso este processo ira remover um funcionario do sistema</Title>
        <SubTitle>usuario selecionado {item.username} </SubTitle>
        <Footer>
          <Button content={"Cancelar"} onClick={onClose} outline />
          <Button
            content={"Excluir"}
            onClick={() =>
              dispatch(
                handleDeleteUser({
                  userId: item._id,
                })
              )
                .then(() => {
                  toastAlert({
                    msg:
                      "Usuario " +
                      item.username +
                      " deletado com sucesso com sucesso!",
                  });
                  onClose();
                  updateFilters({
                    ...typeFilter,
                    page: 1,
                  });
                })
                .catch(() =>
                  toastAlert({
                    msg:
                      "Ocorreu um erro ao deletar o usuario : " +
                      item.username +
                      "!",
                    isError: true,
                  })
                )
            }
          />
        </Footer>
      </Container>
    </Modal>
  );
};

export default DeleteUserModal;
